/** AR08 copy (one group per control; a ticket edits only its own file). */
export const ar08PtBr = {
  title: 'Inadimplência e perdas',
  // Por cliente ainda não é exposto pelo seam (customerId só existe internamente); não afirmar
  // "por cliente" aqui até essa lacuna ser resolvida (ver DECISIONS FOR OWNER do fix round 1).
  description: 'Aging dos recebíveis por faixa de vencimento.',
  // Unused now that AR08 is AVAILABLE (prerequisite copy only renders for "Em breve" rows); kept
  // for history, matching the stub-era wording.
  prerequisite: 'Requer o aging dos recebíveis.',
  reviewRequired:
    'A estimativa de perdas da carteira não é calculada: não há modelo de PDD/perda esperada no sistema. Revisão manual é necessária.',
  buckets: {
    CURRENT: 'A vencer',
    '1_30': '1–30 dias',
    '31_60': '31–60 dias',
    '61_90': '61–90 dias',
    '91_180': '91–180 dias',
    OVER_180: 'Mais de 180 dias',
  },
  migratedSuffix: 'migrados',
  coverageLimits:
    'Limites de cobertura: {{count}} título(s) sem data de vencimento ou com um caminho não suportado.',
  reasons: {
    NOT_ISSUED_AFTER_ISSUE: 'Fatura ainda não emitida depois da data de emissão registrada.',
    ALLOWANCE_TIE_OUT_NOT_EVALUATED: 'Conferência do saldo de PDD com o razão: não verificada',
    WRITE_OFF_ON_SETTLED_TITLE: 'Baixa como perda de título já recebido',
    LOSS_LINE_TITLE_UNKNOWN: 'O efeito de perda aponta para um título fora do aging deste período.',
  },
  breakdownUnavailable: 'Detalhamento por faixa indisponível acima de 100 títulos.',
  lossReview: {
    title: 'Revisão de perdas e baixas',
    state: {
      valid: 'Aprovada',
      missing: 'Sem revisão',
      rejected: 'Rejeitada',
      invalidated: 'Revisão invalidada',
      unavailable: 'indisponível',
    },
    notPosted: '{{count}} efeito(s) aprovado(s) sem lançamento contábil válido na data-base.',
    reversed: '{{count}} efeito(s) aprovado(s) com o lançamento estornado.',
    writeOffUnsupported:
      '{{count}} baixa(s) aprovada(s): o título ainda está em aberto na subcontábil (sem caminho de baixa no sistema).',
    writeOffSettled_one: '{{count}} baixa como perda de título já recebido.',
    writeOffSettled_other: '{{count}} baixas como perda de títulos já recebidos.',
    titleUnknown_one: '{{count}} efeito aponta para título fora do aging deste período.',
    titleUnknown_other: '{{count}} efeitos apontam para títulos fora do aging deste período.',
    allowanceTieOutNotEvaluated: 'Conferência do saldo de PDD com o razão: não verificada',
  },
  observations: {
    notIssued_one: '{{count}} fatura ainda não emitida (fora do aging)',
    notIssued_other: '{{count}} faturas ainda não emitidas (fora do aging)',
    creditSettled_one: '{{count}} título quitado com crédito do cliente',
    creditSettled_other: '{{count}} títulos quitados com crédito do cliente',
  },
};

export const ar08En: typeof ar08PtBr = {
  title: 'Delinquency and losses',
  description: 'Receivables aging by due-date bucket.',
  prerequisite: 'Needs the receivables aging.',
  reviewRequired:
    'Portfolio-loss estimation is not computed: there is no PDD/expected-loss model in the system. Manual review is required.',
  buckets: {
    CURRENT: 'Current',
    '1_30': '1–30 days',
    '31_60': '31–60 days',
    '61_90': '61–90 days',
    '91_180': '91–180 days',
    OVER_180: 'Over 180 days',
  },
  migratedSuffix: 'migrated',
  coverageLimits: 'Coverage limits: {{count}} title(s) with no due date or an unsupported path.',
  reasons: {
    NOT_ISSUED_AFTER_ISSUE: 'Invoice remains in a pre-issue status despite an issue date.',
    ALLOWANCE_TIE_OUT_NOT_EVALUATED: 'Allowance balance tie-out to the ledger: not checked',
    WRITE_OFF_ON_SETTLED_TITLE: 'Write-off of a title already collected',
    LOSS_LINE_TITLE_UNKNOWN: 'The approved loss effect points outside this period aging population.',
  },
  breakdownUnavailable: 'Bucket breakdown unavailable above 100 titles.',
  lossReview: {
    title: 'Loss and write-off review',
    state: {
      valid: 'Approved',
      missing: 'No review',
      rejected: 'Rejected',
      invalidated: 'Review invalidated',
      unavailable: 'unavailable',
    },
    notPosted: '{{count}} approved effect(s) without a valid posted journal at cutoff.',
    reversed: '{{count}} approved effect(s) whose journal was reversed.',
    writeOffUnsupported:
      '{{count}} approved write-off(s): the title is still open in the subledger (no write-off path exists in the system).',
    writeOffSettled_one: '{{count}} write-off for a title already collected.',
    writeOffSettled_other: '{{count}} write-offs for titles already collected.',
    titleUnknown_one: '{{count}} effect points outside this period aging population.',
    titleUnknown_other: '{{count}} effects point outside this period aging population.',
    allowanceTieOutNotEvaluated: 'Allowance balance tie-out to the ledger: not checked',
  },
  observations: {
    notIssued_one: '{{count}} invoice not yet issued (outside aging)',
    notIssued_other: '{{count}} invoices not yet issued (outside aging)',
    creditSettled_one: '{{count}} title settled with customer credit',
    creditSettled_other: '{{count}} titles settled with customer credit',
  },
};
